// Match the server's Connect readiness rule, including Ecuador recipient accounts.
export function swapPayoutReady(status) {
  const account = status?.profile
  return Boolean(account?.account_id && account.status === 'ready' && account.ready_to_charge_card && account.details_submitted && !account.disabled_reason && !account.requirements_currently_due?.length)
}
